export default "__VITE_ASSET__B4bbMmt4__"